import { Card } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
